import React, { Component } from 'react'
import MyNavbar from "../../components/Navbar/MyNavbar";
import Project from '../../components/Ticket/ProjectDetail/Project';
export default class ProjectDetailPage extends Component {
    
    render() {
        return (
            <div>
                 <MyNavbar />
                 <Project />
            </div>
        )
    }
}
